var render = function render(){var _vm=this,_c=_vm._self._c;return _c('dx-modal',{attrs:{"title":"Conta do paciente","id":"branch-account-modal-page","size":"xl"},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_c('account-data',{attrs:{"id":_vm.id}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }